//@flow

import React from "react";
import { Field } from "react-final-form";
import type { FieldRenderProps } from "react-final-form";
import * as googleLibphonenumber from "google-libphonenumber";
import { changeServiceFormInteraction, formValidationErrors } from "Commons/Utilities/GoogleTagManager";
import { Input } from "modules/ChangeServiceForm/components/shared/CommonComponents";
import { isPhoneNumberValid } from "Commons/Utilities/validators";

const phoneUtil = googleLibphonenumber.PhoneNumberUtil.getInstance();
const PNF = googleLibphonenumber.PhoneNumberFormat;

// Transform it to be E164 valid in the input but without the area code
const normalizePhone = (value) => {
  if (value) {
    // First round format, manual, only numbers and no 0
    let onlyNumbers = value.replace(/[^\d]/g, "");
    while (onlyNumbers.charAt(0) === "0") onlyNumbers = onlyNumbers.substring(1);
    // Second round format, by the E164 library
    try {
      const number = phoneUtil.parse(onlyNumbers, "DE");
      if (phoneUtil.isPossibleNumber(number)) {
        return phoneUtil.format(number, PNF.E164).replace("+49", "").replace("+49", "").replace(/[^\d]/g, "");
      } else {
        return onlyNumbers;
      }
    } catch (error) {
      return onlyNumbers;
    }
  }
  return "";
};

// Block other values than digits and spaces
const handleKeyPress = (event) => {
  if (!/[0-9 ]+/.test(event.key)) {
    event.preventDefault();
  }
};

const CellPhoneNumber = ({ stepName }: { stepName: string }) => {
  return (
    <Field name={"cellPhoneNumber"} validate={isPhoneNumberValid} format={normalizePhone} formatOnBlur>
      {(props: FieldRenderProps) => {
        return (
          <Input
            fullWidth
            type="tel"
            placeholder="Telefonnummer"
            errorMessage={props.meta.touched && props.meta.error}
            error={props.meta.error && (props.meta.dirty || props.meta.submitFailed) && props.meta.touched}
            {...props.input}
            value={props.input.value || ""}
            autoComplete="phone"
            onBlur={props.input.onBlur}
            onClick={() => changeServiceFormInteraction(stepName, "CELL_PHONE_NUMBER")}
            meta={props.meta}
            afterErrorBlurEvent={() => {
              formValidationErrors(stepName, "VALIDATION", { cellPhoneNumber: props.meta.error });
            }}
            handleKeyPress={handleKeyPress}
          />
        );
      }}
    </Field>
  );
};

export default CellPhoneNumber;
